<template>
	<input type="text" v-model="internal" @blur="blurEvent">
</template>

<script>
export default
{
	props: ['value'],

    data()
    {
        return {
            internal: null
        }
    },

    mounted()
    {
    	this.internal = this.convertToDecimalString(this.value);
    },

    watch:
    {
    	internal(val, old)
    	{
    		this.$emit('input', this.makeFloat(val));
    	},
    },

    methods:
    {
    	makeFloat(value)
    	{
    		if (value == 0) return 0;
    		if (value === null) return null;

    		let float = value;

        	float = float.toString();
        	float = parseFloat(float.replace(',','.').replace(' ',''));

        	if ( ! float || isNaN(float)) return null;

        	return float;
    	},

    	convertToDecimalString(value)
    	{
    		let float = this.makeFloat(value);

    		return float ? float.toFixed(2).replace('.',',') : float;
    	},

        blurEvent()
        {
        	this.internal = this.convertToDecimalString(this.internal);
        }
    },
}
</script>

<style lang="scss" scoped>
input {
    display: inline;
    vertical-align: baseline;
}
</style>


// WEBPACK FOOTER //
// Numeric.vue?0b5570fb